// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 320 ? "41ade5dc" : chunkId) + "." + {"320":"88dd2f85c5ca5ad2","478":"c48035ddbd288503","952":"858b411f2e77c3e6"}[chunkId] + ".js";
};